










































































































































































































import InfiniteLoading, { StateChanger } from "vue-infinite-loading";

import { Ref, Vue, Component, Watch } from "vue-property-decorator";
import router from "@/router/router";
import { Panel } from "../../data/models/Panel";
import ClientPanel from "../../data/models/ClientPanel";

import { BranchFilter } from "@/data/models/BranchFilter";

import { observePanelsOfMemberClients, observePanelsOfClient } from "@/data/repository/PanelRepository";
import { observeMemberClientsPanels, observeClientPanels } from "@/data/repository/ClientPanelRepository";
import { ToolbarContentModule } from "@/store/modules/ToolbarContent";
import {
  calculateIresDeviceSortData,
  DeviceSortData,
  DeviceSortOrder,
  getSortOrderName,
} from "@/data/models/DeviceSortOrder";
import { filterAndSortIresDevices } from "@/utils/IresDeviceSorting";
import {
  advancePage,
  shouldReArmPaging,
} from "@/utils/InfiniteScrollPaging";
import {
  IresDeviceItemData,
  reconcileIresDeviceItems,
} from "@/data/models/IresDeviceItemData";
import {
  getBoolean,
  getNumber,
  setBoolean,
  setNumber,
} from "@/utils/SecureLocalStorage";

import IresDeviceItem from "@/components/devices/IresDeviceItem.vue";
import MenuIconWithSelectionListComponent from "@/components/common/FilterMenu.vue";
import SearchForDeviceComponent from "@/components/devices/SearchForDevice.vue";
import MoveIresDevicesDialog from "@/components/devices/MoveIresDevicesDialog.vue";

import {
  DeviceFilter,
  DeviceScope,
  getFilterName,
  getDeviceScope,
  resolveIresDeviceFilterContext,
} from "@/data/models/DeviceFilter";

import {
  findBranch,
  getBranchesOfClient,
  getClientId,
  getMemberClientIds,
  hasClientEnabledStrictBranchFilters,
  getClientsByIds,
  getClient,
  getClientInfo,
  getClientName,
  findBranchOfMemberClient
} from "@/data/repository/ClientRepository";

import { getDefaultBranchFilterOfUser } from "@/data/repository/UserRepository";

import {
  observeComBoxesOfMemberClients,
  observeComBoxesOfClient,
  observeTestComBoxes,
} from "@/data/repository/ComBoxRepository";
import { ComBox } from "@/data/models/ComBox";
import User from "@/data/models/User";
import BranchFilterSelectorComponent from "@/components/common/BranchFilterSelector.vue";
import { getBranchName } from "@/data/models/Branch";
import { COLOR_DISABLED, COLOR_HEADER_BUTTON, COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK } from "@/utils/colors";
import { themed } from "@/utils/Theme";
import Client from "@/data/models/Client";
import { viewTestHyDryDevicesClientAccess } from "@/permissions/ClientPermissions";
import { 
  allHyDryDevicesAccess, 
  editHyDryDevicesAccess, 
  moveDevicesToClientUserAccess, 
  viewHyDryDevicesOfMemberAccess,
  searchAnyHyDryDeviceAccess, 
  viewClientSelectorAccess
} from "@/permissions/UserPermissions";
import ClientFilterSelectorComponent from "../common/ClientFilterSelector.vue";
import { ClientFilter } from "@/data/models/ClientFilter";
import {
  getLastVisitedItem,
  LAST_VISITED_ITEM_BACKGROUND_STYLE,
  setLastVisitedItem,
  StorageKeyLastVisitedItemLevel,
} from "@/utils/Utils";
import ToolbarOverflowItemComponent from "@/components/common/ToolbarOverflowItem.vue";
import { getEffectiveUser } from "@/utils/ViewAs";
import { getStoredBranchFilterId, setStoredBranchFilterId, removeStoredBranchFilterId } from "@/utils/BranchFilterStorage";

@Component({
  name: "IresDeviceListComponent",
  components: {
    "toolbar-overflow-item": ToolbarOverflowItemComponent,
    "infinite-loading": InfiniteLoading,
    "ires-device-item": IresDeviceItem,
    "menu-icon": MenuIconWithSelectionListComponent,
    "search-for-device": SearchForDeviceComponent,
    "client-filter-selector": ClientFilterSelectorComponent,
    "branch-filter-selector": BranchFilterSelectorComponent,
    "move-ires-devices": MoveIresDevicesDialog,
  },
})
export default class IresDeviceList extends Vue {
  @Ref("searchForIresDevice")
  searchForDeviceComponent!: SearchForDeviceComponent;

  @Ref("moveIresDevices")
  moveIresDevicesDialog!: MoveIresDevicesDialog;

  componentActive = false;

  clientId = getClientId();
  // Whose devices these are; set from the start so the device scope never sees null (ticket 2610052).
  targetUser: User | null = getEffectiveUser();

  panels: Array<IresDeviceItemData> = [];
  comBoxes: Array<IresDeviceItemData> = [];
  testComBoxes: Array<IresDeviceItemData> = [];

  // Row items by serial number, one map per device stream, so a snapshot reuses the
  // instance a row is already bound to instead of replacing it. These are only
  // indexes into the reactive arrays above; Vue 2 cannot track Map contents, and it
  // does not need to, because the arrays are what the template reads. The three
  // streams are kept apart so the test-ComBox view cannot fight with the normal one
  // over a device that appears in both.
  panelItemsBySerialNumber = new Map<string, IresDeviceItemData>();
  comBoxItemsBySerialNumber = new Map<string, IresDeviceItemData>();
  testComBoxItemsBySerialNumber = new Map<string, IresDeviceItemData>();

  showTestComBoxes = false;

  clientPanels: Map<string, ClientPanel> = new Map();
  lastVisitedSerialNumber: string | null = null;

  // Shared reference date for every row's elapsed times, moved once a minute.
  displayDate = new Date();

  refreshTrigger = 0;
  isListRefreshScheduled = false;

  /** Whether every currently known device is on screen; see infiniteHandler. */
  hasDisplayedEveryDevice = false;
  isLoadingPanels = false;
  showNoMatchingPanelsFoundHint = false;

  infiniteId = new Date();
  pageSize = 20;
  sliceLength = this.pageSize;

  isCreating = false;
  isLoading = false;

  currentObservedDeviceScope: DeviceScope | null = null;

  refreshTimer: NodeJS.Timeout | null = null;
  filterRestoreTimer: NodeJS.Timeout | null = null;
  panelsSubscription!: () => void;
  comBoxesSubscription!: () => void;
  testComBoxesSubscription!: () => void;

  administratorClientPanelsSubscription!: () => void;
  clientPanelsSubscription!: () => void;

  storageKeyDeviceFilter = "storageKeyDeviceFilter";
  storageKeySortOrder = "storageKeySortOrder";
  storageKeyShowTestComBoxes = "storageKeyShowTestComBoxes";

  selectedDeviceFilter = DeviceFilter.IN_USAGE;

  allFilters = [
    DeviceFilter.ALL_DEVICES,
    DeviceFilter.IN_USAGE,
    DeviceFilter.ALL_ACTIVE_DEVICES,
    DeviceFilter.ALL_FINISHED_DEVICES,
    DeviceFilter.DEVICES_WITH_ERROR_OR_WARNING,
    DeviceFilter.OVERDUE_DEVICES,
  ];

  selectedSortOrder = DeviceSortOrder.PROJECT;
  allSortOrders = [
    DeviceSortOrder.PROJECT,
    DeviceSortOrder.STATUS,
    DeviceSortOrder.SERIAL_NUMBER,
    DeviceSortOrder.INVENTORY_NUMBER,
    DeviceSortOrder.DRYING_START,
  ];

  panelUpdateDebouncer: NodeJS.Timeout | null = null;
  comBoxUpdateDebouncer: NodeJS.Timeout | null = null;
  comBoxTestingDebouncer: NodeJS.Timeout | null = null;

  restrictToMyDevices: boolean | undefined = true;

  isSelectionMode = false;
  selectedIresDevices: IresDeviceItemData[] = [];

  currentClient: Client | null = null;
  memberClients = new Map<string, Client>();

  get tableHeaderColor() {
    return themed(COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK);
  }
  
  get showLoadingAnimation() {
    return this.isLoading || this.isLoadingPanels;
  }

  @Watch("isAllowedToViewIresDevicesOfMemberClients")
  async onIsAllowedToViewIresDevicesOfMemberClientsChanged() {
    await this.fetchMemberClients();
    this.observeIresDevices();
  }

  /** The user whose view this shows: the chosen one while "Sicht auf" is active (ticket 2610052). */
  get activeUser() {
    return getEffectiveUser();
  }

  get isAllowedToViewClientSelector() {
    return viewClientSelectorAccess(this.activeUser);
  }

  get isAllowedToViewTestHyDryDevices() {
    return viewTestHyDryDevicesClientAccess();
  }

  get isAllowedToSearchForAnyHyDryDevice() {
    return searchAnyHyDryDeviceAccess(this.activeUser);
  }

  get isAllowedToMoveDevicesToAnotherClient() {
    return moveDevicesToClientUserAccess(this.activeUser);
  }

  get isAllowedToViewIresDevicesOfMemberClients() {
    return viewHyDryDevicesOfMemberAccess(this.activeUser);
  }

  get clientInfo() {
    return getClientInfo();
  }

  get memberClientIds() {
    return getMemberClientIds();
  }

  get numberOfDevices() {
    return this.iresDeviceItems.length;
  }

  get selectedPanelFiltersDescription() {
    const numberOfDevices = this.numberOfDevices;
    const numberOfDevicesSelected = this.selectedIresDevices.length;

    let filtersName = this.isSelectionMode
      ? this.$tc("panelList.descriptionAlt", numberOfDevicesSelected).toString()
      : this.$tc("panelList.description", numberOfDevices).toString();
    let isFilterEnabled = false;

    const selectedClientFilterName = this.selectedClientFilter.client
      ? getClientName(this.selectedClientFilter.client)
      : this.$t("common.all");

    if (this.isAllowedToViewClientSelector && selectedClientFilterName !== this.$t("common.all")) {
      filtersName += " (" + selectedClientFilterName;
      isFilterEnabled = true;
    }

    const selectedBranchFilterName = this.selectedBranchFilter.branch
      ? getBranchName (this.selectedBranchFilter.branch)
      : this.$t("common.all");

    if (selectedBranchFilterName !== this.$t("common.all")) {
      filtersName += !isFilterEnabled
        ? " ("
        : "";
      filtersName += (this.isAllowedToViewClientSelector
        ? ": "
        : "") + selectedBranchFilterName;
      isFilterEnabled = true;
    }

    return filtersName + (isFilterEnabled ? ")" : "");
  }

  get selectedMemberClient() {
    return this.isAllowedToViewClientSelector && this.selectedClientFilter.client 
      ? this.selectedClientFilter.client
      : null;
  }

  get showSwitchSelectionModeIcon() {
    return this.allIresDeviceItems.length > 0 &&
      (
        this.isAllowedToMoveDevicesToAnotherClient ||
        (
          this.isAllowedToEditDevices &&
          this.clientInfo?.branches &&
          this.clientInfo.branches.length > 0
        )
      )
      ;
  }

  get areSelectionActionsEnabled() {
    return this.selectedIresDevices.length > 0;
  }

  get isAllowedToEditDevices() {
    return editHyDryDevicesAccess(this.activeUser);
  }

  get isMovingDevicesAllowedForSelection() {
    const isIresDeviceAssignedToProject = this.selectedIresDevices.find((deviceData) => 
      deviceData?.iresDevice.currentAssignment?.currentProjectId && 
      deviceData?.iresDevice.currentAssignment?.currentProjectId !== null &&
      deviceData?.iresDevice.currentAssignment?.currentProjectId !== ""
    );

    return this.showSwitchSelectionModeIcon && this.areSelectionActionsEnabled && !isIresDeviceAssignedToProject;
  }

  get allFiltersName() {
    let filtersName = this.getFilterName(this.selectedDeviceFilter);

    const selectedClientFilterName = this.selectedClientFilter.client
      ? getClientName(this.selectedClientFilter.client)
      : this.$t("common.all");

    if (this.isAllowedToViewClientSelector && selectedClientFilterName !== this.$t("common.all")) {
      filtersName += ", " + selectedClientFilterName;
    }

    const selectedBranchFilterName = this.selectedBranchFilter.branch
      ? getBranchName (this.selectedBranchFilter.branch)
      : this.$t("common.all");

    if (selectedBranchFilterName !== this.$t("common.all")) {
      filtersName += ", " + selectedBranchFilterName;
    }

    return filtersName;
  }

  getSortOrderName(sortOrder: DeviceSortOrder) {
    return getSortOrderName(this, sortOrder);
  }

  getFilterName(deviceFilter: DeviceFilter) {
    return getFilterName(this, deviceFilter);
  }

  clearSelectedIresDevices() {
    this.selectedIresDevices = [];
  }

  toggleSelectionMode() {
    this.clearSelectedIresDevices();

    if (!this.isSelectionMode) {
      this.selectedDeviceFilter = DeviceFilter.ALL_DEVICES;
    }

    setLastVisitedItem(
      null,
      StorageKeyLastVisitedItemLevel.LEVEL_1
    );

    this.refreshLastVisitedSerialNumber();

    this.isSelectionMode = !this.isSelectionMode;
  }

  isIresDeviceSelected(device: IresDeviceItemData) {
    return this.selectedIresDevices.some(
      (selected) => selected.serialNumber === device.serialNumber
    );
  }

  getMoveDevicesIconColor() {
    return this.isMovingDevicesAllowedForSelection
      ? COLOR_HEADER_BUTTON
      : COLOR_DISABLED;
  }

  async moveSelectedDevices() {
    if (this.isSelectionMode) {
      await this.moveIresDevicesDialog.show();
    }
  }

  selectedClientFilter = new ClientFilter();
  selectedBranchFilter = getDefaultBranchFilterOfUser();

  get deviceSortOrderIconRes() {
    return "mdi-sort-alphabetical-variant";
  }

  get deviceFilterIconRes() {
    return "mdi-filter-variant";
  }

  get isDefaultClientFilterSelected() {
    return !this.selectedClientFilter.client?.id;
  }

  get isDefaultBranchFilterSelected() {
    return this.selectedBranchFilter.isDefaultBranchFilter();
  }

  setClientFilterOnActivation() {
    const clientIdQuery = localStorage.getItem("clientFilter");
    const isDefaultClientFilterSelected = localStorage.getItem("isDefaultClientFilter") === "true";
    const isAllowedToViewClientSelector = this.isAllowedToViewClientSelector;

    if (isDefaultClientFilterSelected || !isAllowedToViewClientSelector) {
      if (this.currentClient && !isAllowedToViewClientSelector) {
        this.selectedClientFilter = new ClientFilter(this.currentClient);
      }
      return;
    }

    if (clientIdQuery) {
      const client = this.memberClients.get(clientIdQuery);
      if (client) {
        this.selectedClientFilter = new ClientFilter(client);
      }
    } else {
      this.selectedClientFilter = new ClientFilter(...this.memberClients.values());
    }

    const clientId = this.selectedClientFilter.client?.id;

    if (clientId) {
      localStorage.setItem("clientFilter", clientId);
      localStorage.setItem("isDefaultClientFilter", "true");
    } else {
      localStorage.removeItem("clientFilter");
      localStorage.removeItem("isDefaultClientFilter");
    }
  }

  setBranchFilterOnActivation() {
    const branchIdQuery = getStoredBranchFilterId("branchFilter");
    const isAllowedToViewClientSelector = this.isAllowedToViewClientSelector;
    const memberClient = this.selectedClientFilter.client;
    
    if (branchIdQuery) {
      const matchingBranch = isAllowedToViewClientSelector && memberClient
        ? findBranchOfMemberClient(branchIdQuery, memberClient)
        : findBranch(branchIdQuery);

      if (matchingBranch) {
        this.selectedBranchFilter = new BranchFilter(
          hasClientEnabledStrictBranchFilters(),
          matchingBranch
        );
      }
    }

    if (this.selectedBranchFilter.branch?.id) {
      setStoredBranchFilterId("branchFilter", this.selectedBranchFilter.branch?.id);
    }
    else {
      removeStoredBranchFilterId("branchFilter");
    }
  }

  async activated() {
    const shouldReloadClientPanels = localStorage.getItem("shouldReloadClientPanels");
    if (shouldReloadClientPanels === "true") {
      
      this.observeIresDevices();

      this.resetBranchFilter();
      this.resetDisplayedIresDevices();

      removeStoredBranchFilterId("branchFilter");
      localStorage.removeItem("shouldReloadClientPanels");
    }

    this.restoreFiltersOnceCreated();
    this.refreshLastVisitedSerialNumber();

    // Elapsed times went stale while the timer was stopped.
    this.refreshDisplayDate();
    this.startRefreshTimer();

    this.componentActive = true;
    this.setToolbarTitle(this.selectedDeviceFilter);

    if (this.isLoading) {
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    }
  }

  /**
   * Restores the stored client and branch filters as soon as `created()` is done.
   *
   * The filters depend on data `created()` loads, so this polls until it has
   * finished. It is stored on the component so re-activating the screen cannot
   * leave a second timer running, and so teardown can stop it.
   */
  restoreFiltersOnceCreated() {
    this.clearFilterRestoreTimer();

    this.filterRestoreTimer = setInterval(() => {
      if (!this.isCreating) {
        this.clearFilterRestoreTimer();

        this.setClientFilterOnActivation();
        this.setBranchFilterOnActivation();
      }
    }, 100);
  }

  clearFilterRestoreTimer() {
    if (this.filterRestoreTimer) {
      clearInterval(this.filterRestoreTimer);
      this.filterRestoreTimer = null;
    }
  }

  deactivated() {
    this.stopRefreshTimer();

    this.isLoading = true;
    this.componentActive = false;
  }

  mounted() {
    this.componentActive = true;
  }

  /**
   * Re-derives the list at most once per tick.
   *
   * Only the minute tick and explicit user actions need this now that rows no longer
   * report sort keys back.
   */
  scheduleListRefresh() {
    if (this.isListRefreshScheduled) {
      return;
    }

    this.isListRefreshScheduled = true;

    this.$nextTick(() => {
      this.isListRefreshScheduled = false;
      this.refreshTrigger++;
    });
  }

  async onSearchForIresDevice() {
    const serialNumber = await this.searchForDeviceComponent.show();

    if (serialNumber) {
      setLastVisitedItem(
        serialNumber,
        StorageKeyLastVisitedItemLevel.LEVEL_1,
      );

      router.push({
        path: `/main/devices/deviceDetail`,
        query: {
          serialNumber: serialNumber.toUpperCase(),
        },
      });
    }
  }

  @Watch("selectedDeviceFilter")
  onFilterChanged(newFilter: DeviceFilter) {
    this.setToolbarTitle(newFilter);

    const newDeviceScope = getDeviceScope(newFilter, this.targetUser);

    if (newDeviceScope !== this.currentObservedDeviceScope) {
      this.observeIotDevices(newDeviceScope);
    }

    this.resetDisplayedIresDevices();
    setNumber(this.storageKeyDeviceFilter, this.selectedDeviceFilter);
  }

  @Watch("selectedClientFilter")
  onClientFilterChanged() {
    let branch = null;
    const branchId = this.selectedBranchFilter.branch?.id;
    const memberClient = this.selectedClientFilter.client;
    
    if (branchId) {
      branch = memberClient
        ? findBranchOfMemberClient(branchId, memberClient)
        : findBranch(branchId);
    }
    
    if (this.isDefaultClientFilterSelected || !branch) {
      this.resetBranchFilter();
    }
    
    this.resetDisplayedIresDevices();
  }

  @Watch("selectedBranchFilter")
  onBranchFilterChanged() {
    this.resetDisplayedIresDevices();
    setBoolean(this.storageKeyShowTestComBoxes, this.showTestComBoxes);
  }

  @Watch("selectedSortOrder")
  onSelectedSortOrderChanged() {
    this.resetDisplayedIresDevices();
    setNumber(this.storageKeySortOrder, this.selectedSortOrder);
  }

  resetClientFilter() {
    this.selectedClientFilter = new ClientFilter();
  }

  resetBranchFilter() {
    this.selectedBranchFilter = new BranchFilter(
      hasClientEnabledStrictBranchFilters()
    );
  }

  setToolbarTitle(newFilter: DeviceFilter) {
    const devicesString = `${this.$t(
      "pages.devices"
    ).toString()} (${this.getFilterName(newFilter)})`;

    // No "(Sicht <name>)" here: the Sicht auf chip beside the title names them (ticket 2610050).
    ToolbarContentModule.setToolbarTitle(devicesString);
  }

  /**
   * Refreshes the display state each row reads off its item: the moment the list
   * was last derived (drives the "last update" text and the 24 h status ring) and
   * the client panel the row joins against.
   */
  syncIresDeviceItemDisplayState(iresDevices: IresDeviceItemData[]) {
    iresDevices.forEach((iresDeviceItem) => {
      iresDeviceItem.updateDate(this.displayDate);
      iresDeviceItem.matchingClientPanel = this.clientPanels.get(
        iresDeviceItem.serialNumber
      );
    });
  }

  get allIresDeviceItems() {
    return this.showTestComBoxes
      ? [...this.testComBoxes]
      : [...this.panels, ...this.comBoxes];
  }

  get iresDeviceItemsToDisplay() {
    return this.iresDeviceItems.slice(0, this.sliceLength);
  }

  get iresDeviceItems(): Array<IresDeviceItemData> {
    this.refreshTrigger;

    const iresDevices = this.allIresDeviceItems;
    this.syncIresDeviceItemDisplayState(iresDevices);

    const deviceSortData = this.buildDeviceSortData(iresDevices);

    return filterAndSortIresDevices(iresDevices, {
      sortOrder: this.selectedSortOrder,
      filter: this.selectedDeviceFilter,
      clientFilter: this.selectedClientFilter,
      branchFilter: this.selectedBranchFilter,
      searchQuery: this.searchQuery,
      targetUser: this.targetUser,
      showTestComBoxes: this.showTestComBoxes,
      restrictToMyDevices: this.restrictToMyDevices,
      isAllowedToViewClientSelector: this.isAllowedToViewClientSelector,
      clientPanels: this.clientPanels,
      deviceSortData,
    });
  }

  async fetchMemberClients() {
    if (this.isAllowedToViewIresDevicesOfMemberClients && this.memberClientIds.length > 0) {
      const memberClientIds = this.memberClientIds;
      this.memberClients = await getClientsByIds(memberClientIds);

      if (this.isAllowedToViewClientSelector && this.memberClients.size > 1) {
        this.selectedClientFilter = new ClientFilter(...this.memberClients.values());
      }
    }
    else {
      const clientId = this.clientId;
      const client = await getClient(this.clientId);
      this.currentClient = client;

      this.memberClients.set(clientId, client);
    }
  }

  observeIresDevices() {
    this.observeIotDevices(getDeviceScope(this.selectedDeviceFilter, this.targetUser));
    this.isAllowedToViewIresDevicesOfMemberClients
      ? this.observeMemberClientsIresDevices()
      : this.observeClientIresDevices();

    return;
  }

  async created() {
    this.isCreating = true;
    this.isLoading = true;

    this.startRefreshTimer();

    const branchIdQuery = router.currentRoute.query["targetBranchId"] as string;

    if (branchIdQuery) {
      const matchingBranch = getBranchesOfClient().find(
        (branch) => branch.id === branchIdQuery
      );

      if (matchingBranch) {
        this.selectedBranchFilter = new BranchFilter(
          hasClientEnabledStrictBranchFilters(),
          matchingBranch
        );
      }
    }

    const deviceFilterFromQuery = router.currentRoute.query[
      "deviceFilter"
    ] as string;

    if (deviceFilterFromQuery) {
      this.selectedDeviceFilter = Number.parseInt(deviceFilterFromQuery);
    } else {
      const cachedDeviceFilter =
        getNumber(this.storageKeyDeviceFilter) ?? DeviceFilter.IN_USAGE;

      if (cachedDeviceFilter != null && cachedDeviceFilter !== undefined) {
        this.selectedDeviceFilter = cachedDeviceFilter;
      }
    }

    // "Sicht auf" is one choice for the whole app (ticket 2610050); Scaffold re-creates the page when
    // it changes, so reading it once here is enough.
    this.targetUser = getEffectiveUser();

    const showAllDevicesQuery = router.currentRoute.query[
      "showAllDevices"
    ] as string;

    if (showAllDevicesQuery) {
      this.restrictToMyDevices = showAllDevicesQuery === "false";
    } else {
      const deviceScope = getDeviceScope(
        this.selectedDeviceFilter,
        this.targetUser
      );

      this.restrictToMyDevices =
        deviceScope == DeviceScope.DEVICES_OF_PROJECTS_OF_USER;
    }

    if (!this.restrictToMyDevices) {
      this.allFilters.push(DeviceFilter.NOT_ASSIGNED_TO_PROJECT);
    }

    this.observeIresDevices();

    const cachedSortOrder =
      getNumber(this.storageKeySortOrder) ?? DeviceSortOrder.PROJECT;

    if (cachedSortOrder != null) {
      this.selectedSortOrder = cachedSortOrder;
    }

    await this.fetchMemberClients();

    if (getBoolean(this.storageKeyShowTestComBoxes)) {
      this.toogleTargetComBoxes();
    }

    this.resetDisplayedIresDevices();

    setTimeout(() => {
      this.isLoading = false;
    }, 500);

    this.isCreating = false;
  }

  get noMatchingPanelsFound(): boolean {
    return this.iresDeviceItems.length === 0;
  }

  onSelectIresDevice(device: IresDeviceItemData) {
    if (this.isSelectionMode) {
      const index = this.selectedIresDevices.findIndex(
        (selected) => selected.serialNumber === device.serialNumber
      );
      
      if (index > -1) {
        this.selectedIresDevices.splice(index, 1);
      }
      else {
        this.selectedIresDevices.push(device);
      }
    }
  }

  observeIotDevices(deviceScope: DeviceScope) {
    this.currentObservedDeviceScope = deviceScope;

    const seesAllHyDryDevices = allHyDryDevicesAccess(this.targetUser);

    const userId =
      (!seesAllHyDryDevices &&
      deviceScope == DeviceScope.DEVICES_OF_PROJECTS_OF_USER
        ? this.targetUser?.id
        : null) ?? null;

    if (this.panelsSubscription) {
      this.panelsSubscription();
    }

    if (this.comBoxesSubscription) {
      this.comBoxesSubscription();
    }

    this.panelsSubscription = this.isAllowedToViewIresDevicesOfMemberClients
      ? observePanelsOfMemberClients((update: Array<Panel>) => {
          this.debouncePanelUpdate(update);
        })
      : observePanelsOfClient(
          userId,
          (update: Array<Panel>) => {
            this.debouncePanelUpdate(update);
          }
        );

    this.comBoxesSubscription = this.isAllowedToViewIresDevicesOfMemberClients
      ? observeComBoxesOfMemberClients((update: Array<ComBox>) => {
          this.debounceComBoxUpdate(update);
        })
      : observeComBoxesOfClient(
          userId,
          (update: Array<ComBox>) => {
            this.debounceComBoxUpdate(update);
          }
        );
  }

  /**
   * Disposes both client-panel subscriptions.
   *
   * Both are disposed regardless of the current permission, because a permission
   * change mid-session can leave the other one behind: `observeMemberClientsPanels`
   * opens one listener per member client, so for a master client every orphaned
   * subscription costs dozens of live listeners for the rest of the session.
   */
  releaseClientPanelSubscriptions() {
    if (this.administratorClientPanelsSubscription) {
      this.administratorClientPanelsSubscription();
    }

    if (this.clientPanelsSubscription) {
      this.clientPanelsSubscription();
    }
  }

  observeMemberClientsIresDevices() {
    this.releaseClientPanelSubscriptions();

    this.administratorClientPanelsSubscription = observeMemberClientsPanels(
      (clientPanelsMap: Map<string, ClientPanel>) => {
        this.clientPanels = clientPanelsMap;
        this.isLoadingPanels = false;
      }
    );
  }

  observeClientIresDevices() {
    this.releaseClientPanelSubscriptions();

    this.clientPanelsSubscription = observeClientPanels(
      (clientPanels: Array<ClientPanel>) => {
        const newClientPanels: Map<string, ClientPanel> = new Map();

        clientPanels.forEach((clientPanel) =>
          newClientPanels.set(clientPanel.serialNumber, clientPanel)
        );

        this.clientPanels = newClientPanels;
        this.isLoadingPanels = false;
      }
    );
  }

  /**
   * Seeds sort data for devices that have none yet, so the full list has complete
   * sort keys before the first infinite-scroll slice renders. Without this, devices
   * beyond the initial slice have no entry until their row renders and emits one,
   * which makes the list visibly re-sort as more devices load. The per-row child
   * still refines the value with the real program chain once rendered.
   *
   * Existing entries are never overwritten, for the same reason.
   */
  /**
   * Sort keys for every device, computed in one pass.
   *
   * Deliberately derived only from what the list holds for **all** devices: the device
   * document and its client panel. The program chain is not used, even though it would
   * refine the key, because it is only loaded for rows the user has scrolled to - feeding
   * it in made the order depend on scroll position, and rows already on screen visibly
   * reshuffled as later rows loaded. Measured before this change: the top 50 rows were
   * reordered seven times in the first three seconds of scrolling "Alle Geräte", once
   * moving 42 of the 50.
   *
   * Computed together rather than per device as devices arrive, because the keys hold
   * "minutes since" values: a key computed now and one computed five minutes ago are not
   * comparable, so a partial refresh would itself reorder the list.
   */
  buildDeviceSortData(items: Array<IresDeviceItemData>) {
    const filterContext = resolveIresDeviceFilterContext(this.targetUser);
    const deviceSortData = new Map<string, DeviceSortData>();

    items.forEach((item) =>
      deviceSortData.set(
        item.serialNumber,
        calculateIresDeviceSortData(
          item.iresDevice,
          this.targetUser,
          this.clientPanels.get(item.serialNumber) ?? null,
          null,
          filterContext
        )
      )
    );

    return deviceSortData;
  }

  debounceComBoxUpdate(update: Array<ComBox>) {
    this.clearComBoxUpdateDebouncer();

    this.comBoxUpdateDebouncer = setTimeout(() => {
      const comBoxes = reconcileIresDeviceItems(
        update,
        this.comBoxItemsBySerialNumber,
        new Date()
      );

      this.comBoxes = comBoxes;
    }, 100);
  }

  debounceTestComBoxUpdate(update: Array<ComBox>) {
    this.clearComBoxTestingDebouncer();

    this.comBoxTestingDebouncer = setTimeout(() => {
      this.testComBoxes = reconcileIresDeviceItems(
        update,
        this.testComBoxItemsBySerialNumber,
        new Date()
      );
    }, 100);
  }

  debouncePanelUpdate(update: Array<Panel>) {
    this.clearPanelUpdateDebouncer();

    this.panelUpdateDebouncer = setTimeout(() => {
      const panels = reconcileIresDeviceItems(
        update,
        this.panelItemsBySerialNumber,
        new Date()
      );

      this.panels = panels;
    }, 100);
  }

  /**
   * Moves the reference point every row measures its elapsed times and its 24 h
   * status ring against, and re-derives the list once.
   *
   * The date is held here and shared by every row rather than minted per row per
   * pass: assigning the same instance back is a no-op for Vue, so rows re-render when
   * the minute actually ticks instead of on every filter, sort or search change.
   */
  refreshDisplayDate() {
    this.displayDate = new Date();
    this.scheduleListRefresh();
  }

  /**
   * The screen is kept alive, so without stopping the timer it kept re-deriving the
   * whole list once a minute while the user was on another screen entirely.
   */
  startRefreshTimer() {
    this.stopRefreshTimer();

    this.refreshTimer = setInterval(() => this.refreshDisplayDate(), 60 * 1000);
  }

  stopRefreshTimer() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
      this.refreshTimer = null;
    }
  }

  clearPanelUpdateDebouncer() {
    if (this.panelUpdateDebouncer) {
      clearTimeout(this.panelUpdateDebouncer);
    }
  }

  clearComBoxUpdateDebouncer() {
    if (this.comBoxUpdateDebouncer) {
      clearTimeout(this.comBoxUpdateDebouncer);
    }
  }

  clearComBoxTestingDebouncer() {
    if (this.comBoxTestingDebouncer) {
      clearTimeout(this.comBoxTestingDebouncer);
    }
  }

  isObservingTestComBoxes = false;

  async toogleTargetComBoxes() {
    this.showTestComBoxes = !this.showTestComBoxes;

    if (!this.isObservingTestComBoxes) {
      this.isObservingTestComBoxes = !this.isObservingTestComBoxes;

      this.testComBoxesSubscription = observeTestComBoxes(
        (update: Array<ComBox>) => {
          this.debounceTestComBoxUpdate(update);
        }
      );
    }

    this.resetDisplayedIresDevices();
  }

  beforeDestroy() {
    // Guarded: created() can fail before a subscription exists, and an unguarded
    // call would then throw out of teardown and skip everything after it.
    if (this.panelsSubscription) {
      this.panelsSubscription();
    }

    if (this.comBoxesSubscription) {
      this.comBoxesSubscription();
    }

    if (this.testComBoxesSubscription) {
      this.testComBoxesSubscription();
    }

    this.releaseClientPanelSubscriptions();

    this.clearPanelUpdateDebouncer();
    this.clearComBoxUpdateDebouncer();
    this.clearComBoxTestingDebouncer();
    this.clearFilterRestoreTimer();
    this.stopRefreshTimer();
  }

  resetDisplayedIresDevices() {
    this.sliceLength = this.pageSize;
    this.infiniteId = new Date();
  }

  infiniteHandler(data: StateChanger) {
    const page = advancePage({
      displayedCount: this.sliceLength,
      pageSize: this.pageSize,
      availableCount: this.iresDeviceItems.length,
    });

    this.sliceLength = page.displayedCount;

    // Complete only once every device that is currently known is on screen. The
    // previous condition compared the requested page against how many devices had
    // arrived so far, and the list mounts about half a second after the screen opens
    // while devices are still streaming in: with less than one page loaded it completed
    // immediately, and completing makes the loader drop its scroll listener for good.
    // That left a master client holding the first twenty devices with no way to page
    // further until a filter change happened to re-arm it.
    this.hasDisplayedEveryDevice = page.hasDisplayedEverything;

    if (page.hasDisplayedEverything) {
      data.complete();
    } else {
      data.loaded();
    }
  }

  /**
   * Re-arms the loader when devices arrive after it had run out of them.
   *
   * Changing the identifier is what resets `vue-infinite-loading` back to ready and
   * re-attaches its scroll listener. Without this, every device that arrives after the
   * loader completed would be unreachable.
   */
  @Watch("numberOfDevices")
  onNumberOfDevicesChanged() {
    const needsReArm = shouldReArmPaging({
      hasDisplayedEverything: this.hasDisplayedEveryDevice,
      displayedCount: this.sliceLength,
      availableCount: this.iresDeviceItems.length,
    });

    if (needsReArm) {
      this.hasDisplayedEveryDevice = false;
      this.infiniteId = new Date();
    }
  }

  get showInfiniteLoading() {
    return this.iresDeviceItems.length > 0;
  }

  searchTimeout: NodeJS.Timeout | null = null;
  searchQuery: string | null = null;

  clearSearchQuery() {
    this.searchQuery = null;
    this.resetDisplayedIresDevices();
  }

  debounceSearch(newQuery: string) {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    if (newQuery === "") {
      this.clearSearchQuery();
      return;
    }

    this.searchTimeout = setTimeout(() => {
      this.processSearchQuery(newQuery);
    }, 400);
  }

  processSearchQuery(newQuery: string) {
    this.searchQuery = newQuery;
    this.resetDisplayedIresDevices();
  }

  /**
   * Highlight for the row the user last opened.
   *
   * The last visited serial is resolved once into `lastVisitedSerialNumber` rather
   * than read per row: the underlying value lives in session storage, so
   * `calculateBackgroundStyle` would hit storage once per row on every render, and a
   * computed could not be used because Vue cannot track storage.
   */
  calculateBackgroundStyle(serialNumber: string) {
    return serialNumber === this.lastVisitedSerialNumber
      ? LAST_VISITED_ITEM_BACKGROUND_STYLE
      : "";
  }

  refreshLastVisitedSerialNumber() {
    this.lastVisitedSerialNumber = getLastVisitedItem(
      StorageKeyLastVisitedItemLevel.LEVEL_1
    );
  }
}
